export default {
	title: 'Patients éligibles',
	introduction_open: 'Veuillez renseigner dans l\'espace ci-dessous, le nombre de patients éligibles au '
		+ 'questionnaire qui ont consulté les professionnels médecins traitants et infirmiers '
		+ 'de votre structure / groupement chaque semaine.',
	introduction_closed: 'Nombre de patients éligibles par semaine renseignés durant la période de campagne.',
	eligiblePatientsExplanation: {
		explanationPart1: 'Pour rappel, les patients éligibles sont :'
		+ '<ul><li>Les patients ayant consulté au cabinet ou en téléconsultation avec un MG ou un(e) IDE (exclusion des patients vus à domicile)</li>'
		+ '<li>Les patients âgés d’au moins 18 ans</li>'
		+ '<li>Les patients non orientés aux urgences / à l’hôpital dans l’immédiat à l’issue de la consultation</li>'
		+ '<li>Les patients ayant leur médecin traitant dans la structure / le groupement</li></ul>',
		explanationPart2: 'Si vous ne disposez pas de cette donnée, merci de renseigner le nombre de patients consultés. Les données doivent être rapportées sur une base hebdomadaire, du lundi au dimanche, indépendamment du jour de début de votre campagne. La semaine de référence se clôture systématiquement le dimanche pour la saisie de ces informations.'
	},
	validateBtn: 'Valider',
	textField: {
		placeholder: 'Nombre de patients'
	}
};
